module.exports = "<app-botao-flutuante-voltar [param]=\"param\"></app-botao-flutuante-voltar>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/administrativo/painel-avaliacao-risco/painel-avaliacao-risco.component.html
// module id = ../../../../../src/app/area-restrita/administrativo/painel-avaliacao-risco/painel-avaliacao-risco.component.html
// module chunks = main